import {Link, useParams} from 'react-router-dom';
import React/*, {useState}*/ from 'react';

import {useracc, postApi, putApi, deleteApi, setTitle, consoleLog} from '../../utils/functions';
import {UserContext, TestService} from '../../utils/usercontext';
import EventEmitter from '../../utils/emmiter';
//import Genres from './components/genres/genres';
//import AudioBox from './components/audio/audiobox';
//import moment from 'moment';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import '../components/fontawesome/fontawesome';

//import { Swiper, SwiperSlide } from 'swiper/react';
//import { Autoplay, Pagination, Navigation } from "swiper";
//import 'swiper/css';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Dropdown from 'react-bootstrap/Dropdown';
import Modal from 'react-bootstrap/Modal';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
//import DropdownButton from 'react-bootstrap/DropdownButton';
import Form from 'react-bootstrap/Form';

import '../components/embeds/platforms.css';
//import './css/header.css';

let browser = null;
// child window.
//let popup = null;
// interval

class PortalAdminPlatforms extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
			service: {
				status: false,
				id: this.props.service,
				name: '',
			},
			platforms: {},
			services: [],
			radio: [],
			limit: {active: 0, limit: 0},
			platform: false,
			authentication: false,
			edit: false,
			delete: false,
			login: false,
		};
		this.getPlatforms = this.getPlatforms.bind(this);
		this.showplatforms = this.showplatforms.bind(this);
		this.currentAccount = this.currentAccount.bind(this);
		this.authentication = this.authentication.bind(this);
		this.submitPlatform = this.submitPlatform.bind(this);

		this.changeStatus = this.changeStatus.bind(this);
		this.connectApi = this.connectApi.bind(this);
		this.reconnectApi = this.reconnectApi.bind(this);
		this.disconnectApi = this.disconnectApi.bind(this);
		this.editPlatform = this.editPlatform.bind(this);
		this.loginDetails = this.loginDetails.bind(this);
		this.submitEvent = this.submitEvent.bind(this);
		this.editStreamSettings = this.editStreamSettings.bind(this);
		this.removePlatform = this.removePlatform.bind(this);
    this.changeProfile = this.changeProfile.bind(this);

		this.reOrder = this.reOrder.bind(this);
		this.reOrderSend = this.reOrderSend.bind(this);

		this.createBridge = this.createBridge.bind(this);
		this.removeBridge = this.removeBridge.bind(this);
  };

  async componentDidMount() {
		//document.title = "Mix365 Radio - your music station streaming 24/7";
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
		value.setTheme( getUser );
		await value.setWorker( this.props.service );
		EventEmitter.emit('/client', {data: 'no value'});

		this.getPlatforms();

	}

	componentWillUnmount() {
	}


	async getPlatforms() {
		let params = new URLSearchParams();

		params.append('service', this.state.service.id);

		let x = await postApi(`${this.context.worker[this.props.service]}/v3/admin/platforms`, params);

		consoleLog(x.data);
		//this.setState({status: true, platforms: x.data.platforms, services: x.data.services});
		let service = this.state.service;
		if( x.status === 200 ) {
			if( service.name !== x.data.servicename || service.status === false ) {
				service.name = x.data.servicename;
				service.status = true;
				this.setState({service});
				setTitle('Streaming Platforms', x.data.servicename);
			}
			for( let i in x.data.services ) if( x.data.services[i].order !== parseInt(i) ) {
				await this.reOrderSend(x.data.services[i].id, i);
				x.data.services[i].order = parseInt(i);
			}
			this.setState({platforms: [], services: []},()=>{
				this.setState({platforms: x.data.platforms, services: x.data.services, limit: x.data.limit}, ()=>{
					x = null;
				});
			});
		} else {
			x = null;
		}
		let y = await postApi(`/v3/portal/platforms/radio`, params);
		if( y.status === 200 ) {
			this.setState({radio: y.data.radio?y.data.radio:[]}, ()=>{
				y = null;
			})
		} else {
			y = null;
		}
	}
	

	async showplatforms(item) {
		this.setState({platform: item},()=>{
			try {
				let serveraddress = document.getElementById("serveraddress");//.focus();
				let streamkey = document.getElementById("streamkey");//.focus();
				if( serveraddress ) 
					serveraddress.focus();
				else
					streamkey.focus();
			} catch(error) {

			}
		});
	}


	async currentAccount(url) {
		browser = window.self;
		//popup = 
		browser.open(url, "name");
	}


	async authentication() {
		let auth = document.getElementById("authentication");
		this.setState({authentication: auth.checked});
	}


	async submitPlatform(event) {
		try {
			event.preventDefault();
			let params = new URLSearchParams();
			params.append('service', this.state.service.id);
			params.append('platform', this.state.platform);
			if( this.state.platform === 'audio' ) {
				//params.append('type', document.getElementById('type').value);
				params.append('host', document.getElementById('host').value);
				params.append('port', document.getElementById('port').value);
				params.append('mount', document.getElementById('mount').value);
				params.append('username', document.getElementById('username').value);
				params.append('password', document.getElementById('password').value);
			} else if( this.state.platform === 'Custom' ) {
				params.append('serveraddress', document.getElementById('serveraddress').value);
				params.append('streamkey', document.getElementById('streamkey').value);
				if( this.state.authentication === true ) {
					params.append('username', document.getElementById('username').value);
					params.append('password', document.getElementById('password').value);
				}

			} else {
				params.append('streamkey', document.getElementById('streamkey').value);
			}
			const x = await putApi(`${this.context.worker[this.props.service]}/v3/admin/platforms`, params);
			consoleLog(x.data);
		} catch(error) {

		}
	}


	//---- Methods to my madness
	async changeStatus(id) {
		let services = this.state.services;
		//let status = 0;
		for( let i in services ) {
			if( services[i].id === id ) {
				services[i].status = services[i].status>0?0:1;

				let params = new URLSearchParams();
				params.append('service', this.state.service.id);
				//params.append('platform', edit.id);
				
				//params.append('id', this.state.services[i].id);
				params.append('enable', services[i].status );
				
				//params.append('type', document.getElementById('type').value);
				
				

				let x = await putApi(`${this.context.worker[this.props.service]}/v3/admin/platforms/${this.state.services[i].id}`, params);
				if( x.status !== 200 ) services[i].status = services[i].status>0?0:1;

			}
		}
		this.setState({services});
	}


	async connectApi(id, platform) {
		let params = new URLSearchParams();
		params.append('service', this.state.service.id);
		params.append('id', id);
		params.append('platform', platform);
		let x = await postApi(`/v3/portal/platforms`, params);
		consoleLog(x.data);
		//window.open(url, "_blank");
	}


	async reconnectApi(id) {
		let params = new URLSearchParams();
		params.append('service', this.state.service.id);
		params.append('platform', id);
		await postApi(`/v3/portal/platforms`, params);
		//const x = await postApi(`${this.context.worker[this.props.service]}/v3/admin/platforms`, params);
	}


	async disconnectApi(id) {
		let params = new URLSearchParams();
		params.append('service', this.state.service.id);
		params.append('platform', id);
		await deleteApi(`${this.context.worker[this.props.service]}/v3/admin/platformsapi`, params);
		this.getPlatforms();
	}


	async editPlatform(id) {
		this.setState({edit: id});
	}


	async loginDetails(id) {
		this.setState({login: id});
	}

	async submitEvent(event) {
		if( event ) event.preventDefault();
		let params = new URLSearchParams();
		params.append('service', this.state.service.id);
		params.append('id', this.state.login);
		params.append('username', document.getElementById('username_01').value);
		params.append('password', document.getElementById('password_01').value);
		await postApi(`${this.context.worker[this.props.service]}/v3/admin/mixcloud`, params);
		//this.setState({login: false});
	}


	async editStreamSettings() {
		let edit = null;
		for( let i in this.state.services )
			if( this.state.services[i].id === this.state.edit )
				edit = this.state.services[i]
		
		let params = new URLSearchParams();
		params.append('service', this.state.service.id);
		//params.append('platform', edit.id);
		
		params.append('platform', edit.platform.name);
		if( edit.platform.name === 'audio' ) {
			//params.append('type', document.getElementById('type').value);
			params.append('host', document.getElementById('host').value);
			params.append('port', document.getElementById('port').value);
			params.append('mount', document.getElementById('mount').value);
			params.append('username', document.getElementById('username').value);
			params.append('password', document.getElementById('password').value);
		} else if( edit.platform.name === 'Custom' ) {
			params.append('serveraddress', document.getElementById('serveraddress').value);
			params.append('streamkey', document.getElementById('streamkey').value);
			if( this.state.authentication === true ) {
				params.append('username', document.getElementById('username').value);
				params.append('password', document.getElementById('password').value);
			}
		} else {
			params.append('streamkey', document.getElementById('streamkey').value);
		}

		const x = await putApi(`${this.context.worker[this.props.service]}/v3/admin/platforms/${edit.id}`, params);
		consoleLog(x.data);

		if( x.status === 200 ) {
			this.setState({edit: false, authentication: false},()=>{
				this.getPlatforms();
			});
		}
	}


	async removePlatform(item) {
		if( item === this.state.delete.id ) {

			let params = new URLSearchParams();
			params.append('service', this.state.service.id);
			params.append('platform', this.state.delete.id);
			const x = await deleteApi(`${this.context.worker[this.props.service]}/v3/admin/platforms/${this.state.delete.id}`, params);
			if( x.status === 200 ) {
				this.setState({delete: false},()=>{
					this.getPlatforms();
				});
			}
		} else {
			this.setState({delete: item});
		}
	}


  async changeProfile(id, pid) {

    let params = new URLSearchParams();
		params.append('service', this.state.service.id);
    params.append('platform', 'Facebook');
    params.append('profile', pid);

    await putApi(`${this.context.worker[this.props.service]}/v3/admin/platforms/${id}`, params);
		//consoleLog(x.data);
    await this.getPlatforms();

  }


	async reOrder(id, index) {
		try {
			let services = this.state.services;
			let first = services.findIndex(elem=>elem.id === id);
			let second = services.findIndex(elem=>elem.order === index);
			if( !services[first] || !services[second] ) return;
			let temp = services[first];
			services[first] = services[second];
			services[second] = temp;
			for( let i in services ) if( services[i].order !== parseInt(i) ) {
				services[i].order = parseInt(i);
				await this.reOrderSend(services[i].id, services[i].order);
			}
			this.setState({services});
		} catch(error) {
			console.log(error);
		}
	}


	async reOrderSend(id, order) {
		try {
			let params = new URLSearchParams();
			params.append('service', this.state.service.id);
			params.append('order', order);
			await putApi(`${this.context.worker[this.props.service]}/v3/admin/platforms/${id}`, params);
		} catch(error) {
			console.log(error);
		}
	}


	async createBridge(service) {
		let params = new URLSearchParams();
		params.append('service', this.state.service.id);
		params.append('bridge', service);
		let x = await putApi(`/v3/portal/platforms/radio`, params);
		x = null;
		this.setState({platform: false}, ()=>{
			this.getPlatforms();
		});
	}

	async removeBridge(service) {
		let params = new URLSearchParams();
		params.append('service', this.state.service.id);
		params.append('bridge', service);
		let x = await deleteApi(`/v3/portal/platforms/radio`, params);
		x = null;
		await this.getPlatforms();
	}
	
	render() {
		const user = this.context;

		const platforms = Object.keys(this.state.platforms).map((e,i) => {
			if( this.state.platforms[e].name !== 'audio' ) {
				return (
					<Col key={i}>
						<div className="card custom-card">
							<div className="row g-0">
								<div style={{width: 70}}>
									<img src={`https://cloud.ultrastream.io/images/${this.state.platforms[e].avatar}`} className="img-fluid rounded-start" alt="..." style={{maxWidth: 64}} />
								</div>
								<Col>
									<div className="card-body px-2 py-1">
										<p className="card-text">
											<b>{this.state.platforms[e].name}</b><br />
											{this.state.platforms[e].authenticate?
											/*url, id, platform*/
											<a href={this.state.platforms[e].master} target="_blank" rel="noreferrer">
											

												<Button size="sm" onClick={()=>this.connectApi(0, this.state.platforms[e].name)}>Authenticate</Button>
												</a>
											:
												<Button size="sm" onClick={()=>this.showplatforms(this.state.platforms[e].name)}>Enter Stream Key</Button>
											}
											
										</p>
									</div>
								</Col>
							</div>
						</div>
					</Col>
				)
			} else {
				return null;
			}
		});

		const radio = this.state.radio.map((e,i) => {
			return (
				<Col key={i}>
					<div className="card custom-card">
							<div className="row g-0">
								<div style={{width: 70}}>
									<img src={`https://cloud.ultrastream.io/images/${e.avatar}`} className="img-fluid rounded-start" alt="..." style={{maxWidth: 64}} />
								</div>
								<Col>
									<div className="card-body px-2 py-1">
										<p className="card-text">
											<b>{e.productname}</b><br />
											{e.title}<br />
											{!e.bridge &&
												<Button size="sm" onClick={()=>this.createBridge(e.id)}>Add</Button>
											}
										</p>
									</div>
								</Col>
							</div>
						</div>
				</Col>
			)
		});

		const bridges = this.state.radio.filter(elem => elem.bridge).map((e,i) => {
			return (
				<Col key={i}>
					<div className="card custom-card">
						<div className="row g-0">
							<div style={{width: 100}} className={`embed-platforms-twitch embed-platforms-panel`}>
								<div className="text-center" style={{width: '100%'}}>
									<img src={e.avatar?`https://cloud.ultrastream.io/images/${e.avatar}`:e.avatar} className="img-fluid rounded-start" alt="..." style={{maxWidth: 42}} />
								</div>
							</div>
							<Col>
								<div className="card-body pt-2">
									<Row>
										<div className="d-flex align-items-center justify-content-between">
											<div style={{width: '100%'}}>
												<div className="card-text">
													(Bridge) {e.productname}
													<br />
													{/*Status, success, amber, danger*/}
													{e.status === 0 &&<><span className="badge bg-danger-transparent"><FontAwesomeIcon icon="times" /></span> Streaming Disabled</>}
													{e.status === 1 &&<>Streaming Idle</>}
													{e.status === 2 &&<>Live Stream - Streaming</>}
													{/*e.status === 3 &&<>Live Stream - Error</>*/}
													<br />
												</div>
											</div>
											<div className="btn-list" style={{display: 'flex'}}>
												<div className={`toggle toggle-success mb-3 ${e.status>0?'on':''}`} onClick={()=>this.createBridge(e.id)}>
                          <span></span>
                        </div>
												<Dropdown drop={'start'}>
													<Dropdown.Toggle variant="light" id="dropdown-basic" size="sm">
														<FontAwesomeIcon icon="ellipsis-vertical" />
													</Dropdown.Toggle>
													<Dropdown.Menu>
														<Dropdown.Item href="#" onClick={()=>{this.removeBridge(e.id)}}>Remove Platform</Dropdown.Item>
													</Dropdown.Menu>
												</Dropdown>
											</div>
										</div>
									</Row>
								</div>
							</Col>
						</div>
					</div>
				</Col>
			)
		});


		const services = this.state.services.map((e,i) => {
      /*let channel = {};
      if( e.channels ) {
        channel = e.channels.filter(elem=>elem.name===e.username);
        if( channel.length === 1 ) channel = channel[0];
      }*/
			return (
				<Col key={i} xs={12}>
					<div className="card custom-card">
						<div className="row g-0">
							<div style={{width: 100}} className={`embed-platforms-${e.platform.name} embed-platforms-panel`}>
								<div className="text-center" style={{width: '100%'}}>
									<img src={e.avatar?e.avatar:`https://cloud.ultrastream.io/images/${e.platform.avatar}`} className="img-fluid rounded-start" alt="..." style={{maxWidth: 42}} />
								</div>
							</div>
							<Col>
								<div className="card-body pt-2">
									<Row>
										<div className="d-flex align-items-center justify-content-between">
											<div style={{width: '100%'}}>
												{this.state.edit === e.id ?
													<>
														
														{e.platform.name==='Custom'&&
															<>
																<Col md={3}>
																	<div className="mb-2">
																		<label htmlFor="streamkey" className="form-label">Enter your server address:</label>
																	</div>
																</Col>
																<Col md={6}>
																	<input type="text" className="form-control border-success" id="serveraddress" defaultValue={e.address} />
																</Col>
																<Col xs={12}></Col>
																<Col md={3}>
																	<div className="mb-2">
																		<label htmlFor="streamkey" className="form-label">Enter your stream key:</label>
																	</div>
																</Col>
																<Col md={6}>
																	<input type="text" className="form-control border-success" id="streamkey" defaultValue={e.streamkey} />
																</Col>
																<Col xs={12}></Col>
																<Col md={3}>
																	<div className="mb-2">
																		<label htmlFor="authentication" className="form-label">Use Authentication:</label>
																	</div>
																</Col>
																<Col md={6}>
																	<div className="form-check">
																		<input className="form-check-input" type="checkbox"  id="authentication" onClick={this.authentication} />
																	</div>
																</Col>
																<Col xs={12}></Col>
																{this.state.authentication === true &&
																	<>
																		<Col md={3}>
																			<div className="mb-2">
																				<label htmlFor="username" className="form-label">Username:</label>
																			</div>
																		</Col>
																		<Col md={6}>
																			<input type="text" className="form-control border-success" id="username" />
																		</Col>
																		<Col xs={12}></Col>
																		<Col md={3}>
																			<div className="mb-2">
																				<label htmlFor="password" className="form-label">Password:</label>
																			</div>
																		</Col>
																		<Col md={6}>
																			<input type="text" className="form-control border-success" id="password" />
																		</Col>
																		<Col xs={12}></Col>
																	</>
																}
															</>
														}
														{e.platform.name==='audio'&&
															<>
																<Col md={3}>
																	<div className="mb-2">
																		<label htmlFor="host" className="form-label">Host:</label>
																	</div>
																</Col>
																<Col md={6}>
																	<input type="text" className="form-control border-success" id="host" defaultValue={e.host} />
																</Col>
																<Col xs={12}></Col>
																<Col md={3}>
																	<div className="mb-2">
																		<label htmlFor="port" className="form-label">Port:</label>
																	</div>
																</Col>
																<Col md={6}>
																	<input type="number" className="form-control border-success" id="port" defaultValue={e.port} />
																</Col>
																<Col xs={12}></Col>
																<Col md={3}>
																	<div className="mb-2">
																		<label htmlFor="mount" className="form-label">Mount:</label>
																	</div>
																</Col>
																<Col md={6}>
																	<input type="text" className="form-control border-success" id="mount" defaultValue={e.mount} />
																</Col>
																<Col xs={12}></Col>
																<Col md={3}>
																	<div className="mb-2">
																		<label htmlFor="username" className="form-label">Username:</label>
																	</div>
																</Col>
																<Col md={6}>
																	<input type="text" className="form-control border-success" id="username" defaultValue={e.username} />
																</Col>
																<Col xs={12}></Col>
																<Col md={3}>
																	<div className="mb-2">
																		<label htmlFor="password" className="form-label">Password:</label>
																	</div>
																</Col>
																<Col md={6}>
																	<input type="text" className="form-control border-success" id="password" defaultValue={e.password} />
																</Col>
																<Col xs={12}></Col>
															</>
														}
														{(e.platform.name!=='Custom'&&e.platform.name!=='audio')&&
															<Col xs={12}>
																<div className="mb-2">
																	<label htmlFor="streamkey" className="form-label">Stream key:</label>
																	<input type="text" className="form-control border-success" id="streamkey" defaultValue={e.streamkey} />
																</div>
															</Col>
														}

														



														<Col xs={12}>
															{e.platform.stream_key_link &&
																<><a href={e.platform.stream_key_link} target="_blank" rel="noreferrer"><Button size="sm">Open {e.platform.name}</Button></a>&nbsp;</>
															}
															<Button size="sm" variant="secondary" onClick={()=>this.editPlatform(false)}>Cancel</Button>
															<Button size="sm" onClick={()=>this.editStreamSettings()}>Save</Button>
														</Col>
													</>
												:
													<>
														<div className="card-text">

															{(e.channels && e.channels.length > 0) ?
																<>
																	<ButtonGroup variant="outline-light">
																		<Button variant="outline-light" disabled={true}>Please select from one of the following:</Button>
																	</ButtonGroup><br />
																	<ButtonGroup variant="outline-light">
																		{e.channels.map((f,j) => {
																			return (
																				<Button key={j} variant="outline-light " style={{minWidth: 150, paddingTop: 30, paddingBottom:20}} onClick={()=>this.changeProfile(e.id, f.id)}>
																					<div>
																						{f.type==='Profile'&&<FontAwesomeIcon icon="user" size="2xl" />}
																						{f.type==='Group'&&<FontAwesomeIcon icon="people-group" size="2xl" />}
																						{f.type==='Page'&&<FontAwesomeIcon icon="newspaper" size="2xl" />}
																					</div>
																					<div style={{paddingTop: 10}}>
																						{f.type}
																					</div>
																					<div>
																						{f.name}
																					</div>
																					</Button>
																			)
																		})}
																		

																		{/*<DropdownButton as={ButtonGroup} title="&#9660;" id="bg-nested-dropdown" variant="outline-light">
																			{e.channels.map((f,j) => {
																				return (
																					<Dropdown.Item key={j} eventKey={j} style={{width: 200}} onClick={()=>this.changeProfile(e.id, f.id)}>{f.type} - {f.name}</Dropdown.Item>
																				)
																			})}
																		</DropdownButton>*/}
																	</ButtonGroup>
																</>
															:
																<>
																	{e.platform.name}
																	{(e.platform.name!=='Custom'&&e.platform.name!=='audio') ?
																		<>
																			{e.username &&
																				<>: {e.username}</>
																			}
																			{e.channels &&
																				<>&nbsp;+</>
																			}
																		</>
																		:
																		<> - {e.host}</>
																	}
																</>
															}
															

															
															<br />
															{/*Status, success, amber, danger*/}
															{e.status === 0 &&<><span className="badge bg-danger-transparent"><FontAwesomeIcon icon="times" /></span> Streaming Disabled</>}
															{e.status === 1 &&<>Streaming Idle</>}
															{e.status === 2 &&<>Live Stream - Streaming</>}
															{/*e.status === 3 &&<>Live Stream - Error</>*/}
															<br />
															
															{(e?.connected === false) &&
																<>
																	<br />
																	<Link to={e.platform.master} target="_blank"><Button size="sm">Re-Authenticate</Button></Link>
																</>
															}
															
															{/*Last Message: */}
														</div>
														{e.master &&
															<a href={e.master} target="_blank" rel="noreferrer"><Button size="sm" onClick={()=>this.connectApi(e.id, e.name)}>Connect API</Button></a>
														}
													</>
												}
												
											</div>
											<div className="btn-list" style={{display: 'flex'}}>
												<div className={`toggle toggle-success mb-3 ${e.status>0?'on':''}`} onClick={()=>this.changeStatus(e.id)}>
                          <span></span>
                        </div>
												<Dropdown drop={'start'}>
													<Dropdown.Toggle variant="light" id="dropdown-basic" size="sm">
														<FontAwesomeIcon icon="ellipsis-vertical" />
													</Dropdown.Toggle>

													<Dropdown.Menu>
														{(e.platform.name!=='Custom'&&e.platform.name!=='audio') &&
															<>
																{/*<Dropdown.Item href="#" disabled={e.master?false:true} onClick={()=>this.connectApi(e.id, e.name)}>Connect API</Dropdown.Item>*/}
																<Dropdown.Item href={e.platform.master?e.platform.master:'#'} target="_blank" /*disabled={e.platform.master?true:false}*/ onClick={()=>this.connectApi(e.id, e.platform.name)}>Re-Authenticate</Dropdown.Item>
																{/*<Dropdown.Item href="#" disabled={e.master?true:false} onClick={()=>this.disconnectApi(e.id)}>Disconnect API</Dropdown.Item>*/}
																<Dropdown.Divider />
															</>
														}
														{(user?.user?.admin && e.platform.name==='Mixcloud' ) &&
															<Dropdown.Item href="#" onClick={()=>this.loginDetails(e.id)}>Enter Login Details</Dropdown.Item>
														}
														<Dropdown.Item href="#" disabled={(e.platform.name==='Custom'||e.platform.name==='audio')?true:false} onClick={()=>this.editPlatform(e.id)}>Edit Stream Key</Dropdown.Item>
														<Dropdown.Item href="#" disabled={(e.platform.name==='Custom'||e.platform.name==='audio')?false:true} onClick={()=>this.editPlatform(e.id)}>Edit Stream Settings</Dropdown.Item>
														<Dropdown.Divider />
														<Dropdown.Item href="#" onClick={()=>{this.removePlatform(e)}}>Remove Platform</Dropdown.Item>
														
													</Dropdown.Menu>
												</Dropdown>

												<div style={{marginTop: -8, padding: 0}}>
													<div style={{cursor: 'pointer', padding: '0 10px', margin: 0}} onClick={()=>this.reOrder(e.id, e.order-1)}>
														<FontAwesomeIcon icon="caret-up" />
													</div>
													<div style={{cursor: 'pointer', padding: '0 10px', margin: 0}} onClick={()=>this.reOrder(e.id, e.order+1)}>
														<FontAwesomeIcon icon="caret-down" />
													</div>
												</div>
												{/*<Button size="sm">Remove</Button>
												<button aria-label="button" type="button" className="btn btn-icon btn-light btn-sm"><i className="ri-thumb-up-line"></i></button>
												<button aria-label="button" type="button" className="btn btn-icon btn-light btn-sm"><i className="ri-chat-2-line"></i></button>*/}
											</div>
										</div>
									</Row>
								</div>
								

								{/*<div className="card-footer">
									<div className="d-flex align-items-center justify-content-between">
										<div className="d-flex align-items-center">
											{/*<div className="avatar avatar-sm avatar-rounded me-2">
												<img src="../assets/images/faces/7.jpg" alt="" />
											</div>
											<div>
												<p className="mb-0 fw-semibold">Maria Bose</p><p className="text-muted fs-10 mb-0">17,Dec 2023 - 12:32</p>
											</div>*}
										</div>
										
									</div>
								</div>*/}
							</Col>
						</div>
					</div>
				</Col>
			)
		});

		let active = this.state.services.filter(elem=>elem.status>0);

		return (
			<>

				<div className="d-sm-flex d-block align-items-center justify-content-between page-header-breadcrumb">
					<h4 className="fw-medium mb-0">Streaming Platforms</h4>
					<div className="ms-sm-1 ms-0">
						<nav>
							<ol className="breadcrumb mb-0">
								<li className="breadcrumb-item"><Link to={`/${this.state.service.id}`}>{this.state.service.name}</Link></li>
								<li className="breadcrumb-item active" aria-current="page">Dashboard</li>
							</ol>
						</nav>
					</div>
				</div>

				{this.state.service.status === true &&
					<div className="main-content app-content">
						<div className="container-fluid">
							<Row>
									
								<Col lg={12}>
                  <div className="card custom-card">
										<div className="card-header p-0">
											<div className="d-flex p-3 ">
												<div className="">
													<svg className="me-4  bg-success-transparent  alt-notify" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="#75cfa5" d="m20.34 9.32-13.99-7a3 3 0 0 0-4.08 3.9L4.41 11l.26.59a1.06 1.06 0 0 1 0 .82l-.26.59-2.14 4.78a2.954 2.954 0 0 0 .67 3.38A2.966 2.966 0 0 0 5 22a3.141 3.141 0 0 0 1.35-.32l13.99-7a2.993 2.993 0 0 0 0-5.36Z"></path><path fill="#198754" d="M14.46 12a.997.997 0 0 1-1 1H4.41l.26-.59a1.06 1.06 0 0 0 0-.82L4.41 11h9.05a.997.997 0 0 1 1 1Z"></path></svg>
												</div>
												<div className="mt-0 text-start">
													<span className="fs-14 fw-semibold">Streaming Platforms</span>
													<p className="fs-13 text-muted mb-0">Connect your outgoing streams</p>
												</div>
                      </div>
											<TestService service={this.state.service.id} worker={user.worker[this.state.service.id]} />
											<div className="card-body">
												<Button size="sm" onClick={()=>this.showplatforms((this.state.platform==='audio'||this.state.platform==='radio')?true:this.state.platform===false?true:false)}>{(this.state.platform==='audio'||this.state.platform==='radio')?'Add':this.state.platform===false?'Add':'Close'} Streaming Platform</Button>
												<Button size="sm" onClick={()=>this.showplatforms(this.state.platform==='audio'?false:'audio')}>{this.state.platform==='audio'?'Close':'Add'} Audio Platform</Button>
												{this.state.radio.length > 0 &&
													<Button size="sm" onClick={()=>this.showplatforms(this.state.platform==='radio'?false:'radio')}>{this.state.platform==='radio'?'Close':'Add'} Radio Platform</Button>
												}
											</div>
                    </div>
										
										
                  </div>
                </Col>

								{this.state.platform === 'audio' &&
									<Col xs={12}>
										<div className="card custom-card">
											<div className="card-header">
												<span className="fs-14 fw-semibold">Audio Source Details</span>
											</div>
											<div className="card-body">
												<p>
													This is to replace any outgoing sources that your DJ's maybe required to use, in the case where DJ's are required to use Butt or any alternative audio streaming sources.<br />(shoutcast / icasecast services such as zeno or azuracast)
												</p>
												Please add your audio source details:
												<Row>
													{/*<Col md={3}>
														<div className="mb-2">
															<label className="form-label">Type:</label>
														</div>
													</Col>
													<Col md={6}>
														<select className="form-select" id="type" aria-label="Default select example">
															<option value="shoutcast">Shoutcast</option>
															<option value="icecast">Icecast 1</option>
															<option value="icecast2">Icecast 2</option>
														</select>
													</Col>
													<Col xs={12}></Col>*/}
													<Col md={3}>
														<div className="mb-2">
															<label htmlFor="host" className="form-label">Host:</label>
														</div>
													</Col>
													<Col md={6}>
														<input type="text" className="form-control border-success" id="host" />
													</Col>
													<Col xs={12}></Col>
													<Col md={3}>
														<div className="mb-2">
															<label htmlFor="port" className="form-label">Port:</label>
														</div>
													</Col>
													<Col md={6}>
														<input type="number" className="form-control border-success" id="port" placeholder={8000} />
													</Col>
													<Col xs={12}></Col>
													<Col md={3}>
														<div className="mb-2">
															<label htmlFor="mount" className="form-label">Mount:</label>
														</div>
													</Col>
													<Col md={6}>
														<input type="text" className="form-control border-success" id="mount" placeholder='/' />
													</Col>
													<Col xs={12}></Col>
													<Col md={3}>
														<div className="mb-2">
															<label htmlFor="username" className="form-label">Username:</label>
														</div>
													</Col>
													<Col md={6}>
														<input type="text" className="form-control border-success" id="username" placeholder='source' />
													</Col>
													<Col xs={12}></Col>
													<Col md={3}>
														<div className="mb-2">
															<label htmlFor="password" className="form-label">Password:</label>
														</div>
													</Col>
													<Col md={6}>
														<input type="text" className="form-control border-success" id="password" />
													</Col>
													<Col xs={12}></Col>
												</Row>
												<div className="">
													<Button size="sm" onClick={this.submitPlatform}>Add Platform</Button>
												</div>
											</div>
										</div>
									</Col>
								}
								{this.state.platform === 'radio' &&
									<Col xs={12}>
										<div className="card custom-card">
											<div className="card-header">
												<span className="fs-14 fw-semibold">Bridge Radio Station</span>
											</div>
											<div className="card-body">
												<p>
													Connect your current restreaming service with your radio station:
												</p>
												<Row>
													{radio}
												</Row>
											</div>
										</div>
									</Col>
								}
								{this.state.platform !== 'audio' && this.state.platform !== 'radio' &&
									<>
										{this.state.platform !== false &&
											<Col lg={12}>
												<div className="card custom-card">
													<div className="card-header">
														<span className="fs-14 fw-semibold">Please select a streaming platform</span>
													</div>
													<div className="card-body">
														<Row>
															{platforms}

															{this.state.platform === 'Custom' ?
																<div className="card">
																	<div className="card-body">
																		<Row>
																			<Col md={3}>
																				<div className="mb-2">
																					<label htmlFor="streamkey" className="form-label">Enter your server address:</label>
																				</div>
																			</Col>
																			<Col md={6}>
																				<input type="text" className="form-control border-success" id="serveraddress" placeholder='rtmp://' />
																			</Col>
																			<Col xs={12}></Col>
																			<Col md={3}>
																				<div className="mb-2">
																					<label htmlFor="streamkey" className="form-label">Enter your stream key:</label>
																				</div>
																			</Col>
																			<Col md={6}>
																				<input type="text" className="form-control border-success" id="streamkey" />
																			</Col>
																			<Col xs={12}></Col>
																			<Col md={3}>
																				<div className="mb-2">
																					<label htmlFor="authentication" className="form-label">Use Authentication:</label>
																				</div>
																			</Col>
																			<Col md={6}>
																				<div className="form-check">
																					<input className="form-check-input" type="checkbox"  id="authentication" onClick={this.authentication} />
																				</div>
																			</Col>
																			<Col xs={12}></Col>
																			{this.state.authentication === true &&
																				<>
																					<Col md={3}>
																						<div className="mb-2">
																							<label htmlFor="username" className="form-label">Username:</label>
																						</div>
																					</Col>
																					<Col md={6}>
																						<input type="text" className="form-control border-success" id="username" />
																					</Col>
																					<Col xs={12}></Col>
																					<Col md={3}>
																						<div className="mb-2">
																							<label htmlFor="password" className="form-label">Password:</label>
																						</div>
																					</Col>
																					<Col md={6}>
																						<input type="text" className="form-control border-success" id="password" />
																					</Col>
																					<Col xs={12}></Col>
																				</>
																			}
																		</Row>
																		<div className="">
																			<Button size="sm" onClick={this.submitPlatform}>Add Platform</Button>
																		</div>
																	</div>
																</div>
															:
																<>
																	{this.state.platform !== true &&
																		<div className="card">
																			<div className="card-body">
																				<div className="mb-2">
																					<label htmlFor="streamkey" className="form-label">Enter your {this.state.platforms[this.state.platform].name} stream key:</label>
																					<input type="text" className="form-control border-success" id="streamkey" />
																				</div>
																				
																				<div className="">
																					<Button size="sm" onClick={this.submitPlatform}>Add Platform</Button>
																					{this.state.platforms[this.state.platform].stream_key_link && 
																						<Button size="sm" onClick={()=>this.currentAccount(/*this.state.platforms[e].stream_key_link*/)}>Open {this.state.platform}</Button>
																					}
																				</div>
																			</div>
																		</div>
																	}
																</>
															}
						
															

					

														</Row>
													</div>
													{/*<div className="card-header">
														<span className="fs-14 fw-semibold">Or select a custom streaming service</span>
													</div>
													<div className="card-body">
														Add custom server
													</div>*/}
												</div>
											</Col>
										}
									</>
								}
								
									
								<Col lg={12}>
                  <div className="card custom-card">
										<div className="card-header">
											<span className="fs-14 fw-semibold">Current outgoing platforms</span>
                    </div>
										<div className="card-body">
											<p>Current number of streams: {active.length}<br />
											Maximum number of streams: {this.state.limit?.limit}</p>
										</div>
										<div className="card-body">
											<Row>
												{services}
												{bridges}
											</Row>
										</div>
										
                  </div>
                </Col>

							</Row>
						</div>
					</div>
				}
				<Modal show={this.state.delete!==false} onHide={()=>{this.removePlatform(false)}} centered>

					<Modal.Header closeButton>
						<Modal.Title id="contained-modal-title-vcenter">
							Remove Platform
						</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						{this.state.delete.platform &&
							<p>
								Are you sure you wish to remove this platform?<br /><br />
								{this.state.delete.platform.name} - {this.state.delete.streamkey?this.state.delete.streamkey:this.state.delete.address}
								<br /><br />
								All API connections to this platform will also be removed.
							</p>
						}
					</Modal.Body>
					<Modal.Footer>
						<Button variant="secondary" onClick={()=>{this.removePlatform(false)}}>Cancel</Button>
						<Button onClick={()=>{this.removePlatform(this.state.delete.id)}}>Remove Platform</Button>
					</Modal.Footer>

				</Modal>

				<Modal show={this.state.login!==false} onHide={()=>{this.loginDetails(false)}} centered>

					<Modal.Header closeButton>
						<Modal.Title id="contained-modal-title-vcenter">
							Login Details
						</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						
						<Form onSubmit={(e)=>this.submitEvent(e)}>
							<div className="form-group row pt-1 pb-0 mb-1">
								<label htmlFor="username_01" className="col-sm-4 col-form-label col-form-label-sm ps-4 text-vcenter">
									<strong>Username</strong><br />
								</label>
								<div className="col-md-6 p-1">
									<Form.Control type="text" name="username_01" id="username_01" className="form-control-sm" placeholder="Username" />
								</div>
							</div>
							<div className="form-group row pt-1 pb-0 mb-1">
								<label htmlFor="password_01" className="col-sm-4 col-form-label col-form-label-sm ps-4 text-vcenter">
									<strong>Password</strong><br />
								</label>
								<div className="col-md-6 p-1">
									<Form.Control type="password_01" name="password" id="password_01" className="form-control-sm" placeholder="Password" />
								</div>
							</div>
						</Form>
							
					</Modal.Body>
					<Modal.Footer>
						<Button variant="secondary" onClick={()=>{this.loginDetails(false)}}>Cancel</Button>
						<Button onClick={()=>{this.submitEvent()}}>Save</Button>
					</Modal.Footer>

				</Modal>
			</>
		);
	}
}

const Platforms = props => {
  const { service } = useParams();
  return <PortalAdminPlatforms service={service} {...props} />
}
export default Platforms;